module.exports = __webpack_public_path__ + "static/media/receive-error.5976e33a.ogg";